<template>
    <div class="right-container">
        <p class="right-h2">关于HTML</p>
        <p class="right-h3">HTML5 doctype</p>
        <p class="right-content">为每个 HTML 页面的第一行添加 <a href="https://developer.mozilla.org/zh-CN/docs/Web/HTML/Quirks_Mode_and_Standards_Mode" target="_blank">standards mode（标准模式）</a> 声明，这样能够确保在每个浏览器中拥有一致的展现。<br>简单来说就是将html声明为HTML5，可以让浏览器更好得去识别网页。</p>
        <div class="right-code">
            <pre>
                <code class="language-markup line-numbers" v-html="code.html.html1"></code>
            </pre>
        </div>
        <p class="right-h3">语言属性</p>
        <p class="right-content">根据 HTML5 规范：强烈建议为 html 根元素指定 lang 属性，从而为文档设置正确的语言。这将有助于语音合成工具确定其所应该采用的发音，有助于翻译工具确定其翻译时所应遵守的规则等等。</p>
        <p class="right-content">具体有哪些值可以参考此 <a href="https://www.runoob.com/tags/html-language-codes.html" target="_blank">网站</a></p>
        <div class="right-code">
            <pre>
                <code class="language-markup line-numbers" v-html="code.html.html2"></code>
            </pre>
        </div>
        <p class="right-h3">IE 兼容模式</p>
        <p class="right-content">IE 支持通过特定的 <code>&lt;meta></code> 标签来确定绘制当前页面所应该采用的 IE 版本。除非有强烈的特殊需求，否则最好是设置为 edge mode，从而通知 IE 采用其所支持的最新的绘制模式。</p>
        <div class="right-code">
            <pre>
                <code class="language-markup line-numbers" v-html="code.html.html3"></code>
            </pre>
        </div>
        <p class="right-h3">字符编码</p>
        <p class="right-content">通过明确声明字符编码，能够确保浏览器快速并容易的判断页面内容的渲染方式。这样做的好处是，可以避免在 HTML 中使用字符实体标记（character entity），从而全部与文档编码一致（一般采用 UTF-8 编码）。</p>
        <div class="right-code">
            <pre>
                <code class="language-markup line-numbers" v-html="code.html.html4"></code>
            </pre>
        </div>
        <p class="right-h3">引入 CSS 和 JavaScript 文件</p>
        <p class="right-content">根据 HTML5 规范，在引入 CSS 和 JavaScript 文件时一般不需要指定 <code>type</code> 属性，因为 <code>text/css</code> 和 <code>text/javascript</code> 分别是它们的默认值。</p>
        <div class="right-code">
            <pre>
                <code class="language-markup line-numbers" v-html="code.html.html5"></code>
            </pre>
        </div>
        <p class="right-h3">viewport</p>
        <p class="right-content">viewport的设置是为了让网页在移动设备上也能正确地显示，响应式网页务必添加这段标签。</p>
        <div class="right-code">
            <pre>
                <code class="language-markup line-numbers" v-html="code.html.html6"></code>
            </pre>
        </div>
        <p class="right-h3">实用为王</p>
        <p class="right-content">尽量遵循 HTML 标准和语义，但是不要以牺牲实用性为代价。任何时候都要尽量使用最少的标签并保持最小的复杂度。</p>
        <p class="right-h3">布尔（boolean）型属性</p>
        <p class="right-content">布尔型属性可以在声明时不赋值。XHTML 规范要求为其赋值，但是 HTML5 规范不需要。</p>
        <div class="right-code">
            <pre>
                <code class="language-markup line-numbers" v-html="code.html.html7"></code>
            </pre>
        </div>
        <p class="right-h3">减少标签的数量</p>
        <p class="right-content">编写 HTML 代码时，尽量避免多余的父元素。很多时候，这需要迭代和重构来实现。请看下面的案例：</p>
        <div class="right-code">
            <pre>
                <code class="language-markup line-numbers" v-html="code.html.html8"></code>
            </pre>
        </div>
        <p class="right-h3">JavaScript 生成的标签</p>
        <p class="right-content">通过 JavaScript 生成的标签让内容变得不易查找、编辑，并且降低性能。能避免时尽量避免。</p>
    </div>
</template>

<script>
import code from '../../utils/code'
import Prism from 'prismjs'
import 'prismjs/themes/prism.css'
export default {
    name: 'reset',
    data () {
        return {
            code: code
        }
    },
    mounted () {
        Prism.highlightAll()
    }
}
</script>

<style lang="scss" scoped>

</style>